import { ContractorPaymentMethod, PaymentLink } from '@/interfaces/brokrete';
import { isEmpty } from '@/libs';
import ICONS from '@/assets/images/icons';

export const getPaymentIcon = (
  paymentMethod: ContractorPaymentMethod | undefined,
  paymentLink: PaymentLink | undefined = undefined
) => {
  if (!isEmpty(paymentLink)) return ICONS.icPaymentLinkXs;
  const { card, provider } = paymentMethod ?? {};

  if (provider === 'card' || provider === 'eway') {
    const brandLowerCase = card?.brand?.toLocaleLowerCase();
    switch (brandLowerCase) {
      case 'visa':
      // return ICONS.icVisaXs;
      case 'mastercard':
      // return ICONS.icMastercard;
      case 'amex':
      // return ICONS.icAmex;
      case 'dinners':
        // return ICONS.icDinners;
        return ICONS.icCard;
    }
  }

  if (provider === 'billd') {
    return ICONS.icBilldXs;
  }

  if (provider === 'flex') {
    return ICONS.icFlexXs;
  }

  if (provider === 'offline') {
    return ICONS.icOffline;
  }

  return ICONS.icCreditAccount;
};
